import { render } from "./list-permission-role.vue?vue&type=template&id=4d7b0566"
import script from "./list-permission-role.vue?vue&type=script&lang=js"
export * from "./list-permission-role.vue?vue&type=script&lang=js"

import "./list-permission-role.vue?vue&type=style&index=0&id=4d7b0566&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__